import { request, API_V1_PREFIX } from "./client";
import type { SchoolProfileData } from "./types";

export async function getSchoolProfiles(token: string): Promise<SchoolProfileData[]> {
  return request<SchoolProfileData[]>(`${API_V1_PREFIX}/school-profiles`, { method: "GET" }, { token });
}

export async function createSchoolProfile(
  data: Pick<SchoolProfileData, "name"> & Partial<Pick<SchoolProfileData, "institution" | "city" | "is_default" | "color">>,
  token: string,
): Promise<SchoolProfileData> {
  return request<SchoolProfileData>(
    `${API_V1_PREFIX}/school-profiles`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    },
    { token },
  );
}

export async function updateSchoolProfile(
  id: string,
  data: Partial<Pick<SchoolProfileData, "name" | "institution" | "city" | "is_default" | "color">>,
  token: string,
): Promise<SchoolProfileData> {
  return request<SchoolProfileData>(
    `${API_V1_PREFIX}/school-profiles/${id}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    },
    { token },
  );
}

export async function deleteSchoolProfile(id: string, token: string): Promise<boolean> {
  return request<boolean>(`${API_V1_PREFIX}/school-profiles/${id}`, { method: "DELETE" }, { token });
}
